import { render, staticRenderFns } from "./popupUpdatePolicy.vue?vue&type=template&id=697f9de4&scoped=true"
import script from "./popupUpdatePolicy.vue?vue&type=script&lang=js"
export * from "./popupUpdatePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f9de4",
  null
  
)

export default component.exports